<template>
  <div class="ui-panel ui-table-scroll">
    <table class="ui-table expiration-table">
      <thead>
        <tr>
          <th class="num">Срок</th>
          <th class="num">Осталось</th>
          <th>Клиент</th>
          <th>Тип</th>
          <th>Продукт / модуль</th>
          <th>Саппортер</th>
          <th>Комментарий</th>
          <th>Менеджер</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="item in items"
          :key="`${item.kind}-${item.property.id}-${item.product.id}-${item.module?.id ?? 's'}-${item.expires_on}`"
          :class="rowClass(item)"
          class="expiration-row"
          @click="goToProperty(item.property.id)"
        >
          <td class="num whitespace-nowrap">{{ formatDate(item.expires_on) }}</td>
          <td class="num">
            <Badge
              :variant="
                item.days_left < 0 ? 'destructive' : item.days_left <= 30 ? 'warning' : 'success'
              "
            >
              {{ daysLabel(item.days_left) }}
            </Badge>
            <Badge v-if="item.support_suspended" variant="destructive" class="ml-1">Пауза</Badge>
          </td>
          <td>
            <router-link
              :to="{ name: 'property-detail', params: { id: item.property.id } }"
              class="property-link ui-link font-medium"
              @click.stop
            >
              {{ item.property.name }}
            </router-link>
          </td>
          <td>
            <Badge :variant="item.kind === 'support' ? 'secondary' : 'outline'">
              {{ item.kind === 'support' ? 'Поддержка' : 'Лицензия' }}
            </Badge>
          </td>
          <td>
            <span class="font-medium">{{ item.product.name }}</span>
            <span v-if="item.module" class="text-muted-foreground">· {{ item.module.name }}</span>
            <div
              v-if="item.support_types?.length || item.support_24on7 || item.support_weekend"
              class="support-meta mt-1"
            >
              <div v-if="item.support_types?.length" class="support-meta-row">
                <span class="text-xs text-muted-foreground">Тип:</span>
                <Badge
                  v-for="supportType in item.support_types"
                  :key="supportType"
                  variant="secondary"
                >
                  {{ supportType }}
                </Badge>
              </div>
              <div v-if="item.support_24on7 || item.support_weekend" class="support-meta-row">
                <span class="text-xs text-muted-foreground">Режим:</span>
                <Badge v-if="item.support_24on7" variant="outline">24/7</Badge>
                <Badge v-if="item.support_weekend" variant="outline">выходные</Badge>
              </div>
            </div>
          </td>
          <td>{{ item.supporter?.name || '—' }}</td>
          <td>
            <span v-if="item.support_notes" class="notes-text" :title="item.support_notes">
              {{ item.support_notes }}
            </span>
            <span v-else class="text-muted-foreground">—</span>
          </td>
          <td class="text-xs text-muted-foreground">
            {{ item.property.manager || item.property.sales_manager || '—' }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script setup lang="ts">
import { Badge } from '@/components/ui/badge';

import { useRouter } from 'vue-router';
import moment from 'moment';

interface Props {
  items: ExpirationItem[];
}

defineProps<Props>();
const router = useRouter();

function goToProperty(id: number) {
  router.push({ name: 'property-detail', params: { id } });
}

function formatDate(date: string): string {
  return moment(date, 'YYYY-MM-DD').format('DD.MM.YYYY');
}

function daysLabel(days: number): string {
  if (days < 0) return `−${Math.abs(days)} дн.`;
  if (days === 0) return 'Сегодня';
  return `${days} дн.`;
}

function rowClass(item: ExpirationItem) {
  if (item.support_suspended) return 'row-suspended';
  if (item.days_left < 0) return 'row-overdue';
  if (item.days_left <= 7) return 'row-soon';
  return '';
}
</script>
